import Desechos from "@/views/Desechos.vue";

const desechos = {
  path: "/app/desechos",
  name: "desechos",
  component: Desechos,
};

export default desechos;
